// components/EmployeeCard.jsx
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import classes from "./employee.module.scss";

const EmployeeCard = ({ employee }) => {
  const { i18n } = useTranslation();

  // Определяем язык для локализации
  const lang = i18n.language;

  // Основная позиция (ранее использовалась как position)
  const position = employee.position || "";

  // Новая локализованная позиция (если есть)
  const simplePosition = employee[`simple_position_${lang}`] || employee.simple_position || "";
  const contact = employee[`contact_${lang}`] || employee.contact || "";


  return (
    <Box className={classes.employeeCard}>
      <Box
        className={classes.employeeImg}
        component="img"
        src={employee.image}
        alt="employee image"
      />
      <Box className={classes.insideContent}>
        <Typography className={classes.name}>{employee.name}</Typography>

        {/* Выводим обе позиции, если доступны */}
        {simplePosition && position ? (
          <>
            <Typography className={classes.position}>{position}</Typography>
            <Typography className={classes.position}>{simplePosition}</Typography>
          </>
        ) : (
          <Typography className={classes.position}>
            {simplePosition || position.slice(0, 60)}
          </Typography>
        )}

        <Typography className={classes.contact}>{contact}</Typography>
      </Box>
    </Box>
  );
};

export default EmployeeCard;